export default function HeroSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
          ICK to STICK Guide
        </h1>
        <p className="text-2xl md:text-3xl text-gray-700 font-light">
          Build partnerships that actually stick (and are a lot more fun)
        </p>
      </div>
    </section>
  );
}
